import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const cards = [
  { titleKey: 'why_1_title', descKey: 'why_1_desc', icon: 'ri-timer-flash-line' },
  { titleKey: 'why_2_title', descKey: 'why_2_desc', icon: 'ri-shield-check-line' },
  { titleKey: 'why_3_title', descKey: 'why_3_desc', icon: 'ri-file-shield-line' },
  { titleKey: 'why_4_title', descKey: 'why_4_desc', icon: 'ri-sparkling-line' },
];

export default function PourquoiNous() {
  const { t } = useTranslation('soumission');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="pourquoi" className="bg-soft-gray py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl">
            {t('why_h2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-start">
          {/* Left: Image */}
          <div
            className={`lg:col-span-4 transition-all duration-1000 delay-100 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <div className="rounded-lg overflow-hidden sticky top-24">
              <img
                src="https://readdy.ai/api/search-image?query=Professional contractor presenting a detailed quote document to a homeowner in front of a Quebec house, clipboard with estimate papers, friendly consultation meeting, warm natural lighting, autumn residential setting with maple trees, documentary business photography style, no text visible"
                alt="Consultation gratuite pour soumission de toiture à Lévis par couvreur certifié RBQ"
                className="w-full h-80 lg:h-[520px] object-cover object-top"
                loading="lazy"
                width="500"
                height="700"
              />
              <div className="bg-slate-primary p-4">
                <p className="text-white/90 text-sm font-medium">
                  <i className="ri-timer-flash-line mr-2 text-copper" />
                  Réponse sous 2 heures
                </p>
              </div>
            </div>
          </div>

          {/* Right: Cards */}
          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {cards.map((card, idx) => (
              <div
                key={idx}
                className={`bg-white rounded-xl p-6 md:p-7 text-center transition-all duration-700 hover:-translate-y-1 hover:shadow-sm ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                style={{ transitionDelay: `${idx * 120 + 200}ms` }}
              >
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-copper/10 mx-auto mb-4">
                  <i className={`${card.icon} text-copper text-2xl`} />
                </div>
                <h3 className="font-manrope font-bold text-slate-primary text-sm md:text-base mb-2">
                  {t(card.titleKey)}
                </h3>
                <p className="text-slate-primary/50 text-xs md:text-sm leading-relaxed">
                  {t(card.descKey)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}